import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Google
 * id 10BF2326-3190-4C27-9040-E2F8F4961238
 * name radiobox-blank
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/radiobox-blank.svg
 * tags
 * - Form 
 */
export const RadioboxBlankIcon = createSvgIcon(<><path d="M12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4A8,8 0 0,1 20,12A8,8 0 0,1 12,20M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z" /></>, 'RadioboxBlankIcon');
export default RadioboxBlankIcon